export const environment = {
  production: false,
  stripePublishableKeyDev: 'pk_test_51PQwgjKYukhS7flDrhbNNGzssEeuyRZvout5NRQfP2JYtODK341rYzEr9MEj6RXWHJAKgKYy7PJN4oUpsva5betM00OVcG6OMZ',
  stripePublishableKeyGamma: 'pk_test_51OzLlzAoITQ9bXcv3S0miyR6Ywz3ddgxD1ckGryRIM7YqRw6WdDKcsQzhIczV0YEsiVOoMaojBFKob1SeJD21ujf00FMy3pxK9',
  stripePublishableKeyProd: 'pk_live_51MgwKpL8bSOS7QQQm6NjntHeRvQiuEShMGoVf8ptjSroUun4BlxpeZ5tF16yPIJheNh1eARRlo2dNfPgeoj6RhQA004gVfYrcO'
};

